/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import HomePanel from "../../components/home/homePanel";
import {withPrefix} from "gatsby";
import {Row, Column} from 'gatsby-theme-carbon';
import locked from "../../images/locked-light.svg";
import slack from "../../images/slack-light-20.svg";
import {ResourceCard} from 'gatsby-theme-carbon';
import "./home-cards.scss";
const MDXLayout = ({children, _frontmatter}) => React.createElement(React.Fragment, null, children);
function _createMdxContent(props) {
  const _components = Object.assign({
    img: "img"
  }, _provideComponents(), props.components);
  return React.createElement(Row, {
    className: "resource-card-group homePanel homePanelRow"
  }, React.createElement(Column, {
    offsetLg: 4,
    colMd: 4,
    colLg: 4,
    colSm: 4,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Contact IBM Accessibility",
    href: "/contact",
    aspectRatio: "2:1",
    actionIcon: "arrowRight"
  })), React.createElement(Column, {
    colMd: 4,
    colLg: 4,
    colSm: 4,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Contact IBM",
    href: "https://www.ibm.com/planetwide/",
    target: "_blank",
    rel: "noopener noreferrer",
    aspectRatio: "2:1",
    actionIcon: "arrowRight"
  })), React.createElement(Column, {
    colMd: 4,
    colLg: 4,
    colSm: 4,
    offsetLg: 4,
    offsetMd: 0,
    noGutterSm: true
  }, React.createElement(ResourceCard, {
    title: "Slack IBM Accessibility",
    href: "https://ibm-studios.slack.com/archives/C036P1CTN",
    target: "_blank",
    rel: "noopener noreferrer",
    aspectRatio: "2:1",
    actionIcon: "arrowRight",
    actionIcon: React.createElement(_components.img, {
      src: locked,
      alt: "Open IBM resource",
      width: 20,
      height: 20,
      style: {}
    })
  }, React.createElement("img", {
    src: slack,
    alt: "Open IBM resource",
    width: 32,
    height: 32,
    style: {}
  }))));
}
function MDXContent(props = {}) {
  return React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props));
}
export default MDXContent;
